import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { DateTime } from "luxon";
import { EventDate } from "../../cards/card-manage-event/types/event-date.type";

export function ticketsDateRangeValidatorFormUpdate(
  eventDate: EventDate,
): ValidatorFn {
  return (form: AbstractControl): ValidationErrors | null => {
    const startDate = DateTime.fromISO(
      `${form.get("start_date")?.value}T${form.get("start_time")?.value}`,
    );
    const endDate = DateTime.fromISO(
      `${form.get("end_date")?.value}T${form.get("end_time")?.value}`,
    );
    const eventStartDate = DateTime.fromISO(
      `${eventDate.startDate}T${eventDate.startTime}`,
    );
    const eventEndDate = DateTime.fromISO(
      `${eventDate.endDate}T${eventDate.endTime}`,
    );
    if (
      !startDate.isValid ||
      !endDate.isValid ||
      !eventStartDate.isValid ||
      !eventEndDate.isValid
    )
      return null;

    if (startDate > endDate) {
      return { dateEndBeforeStart: true };
    } else if (startDate < eventStartDate && endDate > eventStartDate) {
      return { closingAfterEventStart: true };
    } else if (eventEndDate < startDate) {
      return { startDateAfterEventEnd: true };
    } else if (eventEndDate < endDate) {
      return { endDateAfterEventEnd: true };
    } else if (
      Math.floor(startDate.toMillis() / 1000) ===
      Math.floor(endDate.toMillis() / 1000)
    ) {
      return { datesAreEqual: true };
    }

    return null;
  };
}

export function ticketsDateRangeValidatorFormCreate(
  eventDate: EventDate,
): ValidatorFn {
  return (form: AbstractControl): ValidationErrors | null => {
    const startDate = DateTime.fromISO(
      `${form.get("start_date")?.value}T${form.get("start_time")?.value}`,
    );
    const endDate = DateTime.fromISO(
      `${form.get("end_date")?.value}T${form.get("end_time")?.value}`,
    );
    const currentDate = DateTime.local();
    const eventStartDate = DateTime.fromISO(
      `${eventDate.startDate}T${eventDate.startTime}`,
    );
    const eventEndDate = DateTime.fromISO(
      `${eventDate.endDate}T${eventDate.endTime}`,
    );
    if (
      !startDate.isValid ||
      !endDate.isValid ||
      !eventStartDate.isValid ||
      !eventEndDate.isValid
    )
      return null;

    if (startDate > endDate) {
      return { dateEndBeforeStart: true };
    } else if (startDate < currentDate || endDate < currentDate) {
      return { dateBeforeCurrent: true };
    } else if (startDate < eventStartDate && endDate > eventStartDate) {
      return { closingAfterEventStart: true };
    } else if (eventEndDate < startDate) {
      return { startDateAfterEventEnd: true };
    } else if (eventEndDate < endDate) {
      return { endDateAfterEventEnd: true };
    } else if (
      Math.floor(startDate.toMillis() / 1000) ===
      Math.floor(endDate.toMillis() / 1000)
    ) {
      return { datesAreEqual: true };
    }

    return null;
  };
}
